angular.module("app").controller("SkinConfigurationsPageController", [
    '$scope',
    'preloadedConfigs',
    'preloadedConfigTypes',
    'preloadedVersions',
    'configsService',
    'errorHandler',
    'logger',
    'deepCompare',
    '$window',
    '$uibModal',
    'settingsService',
    '$filter',
    '$timeout',
    'userStorage',
    'preloadedSkinsList',
    '$controller',
    function ($scope,
              preloadedConfigs,
              preloadedConfigTypes,
              preloadedVersions,
              configsService,
              errorHandler,
              logger,
              deepCompare,
              $window,
              $modal,
              settingsService,
              $filter,
              $timeout,
              userStorage,
              preloadedSkinsList,
              $controller) {

        var dependency = {
                $scope: $scope,
                preloadedConfigs: preloadedConfigs,
                preloadedConfigTypes: preloadedConfigTypes,
                preloadedVersions: preloadedVersions,
                configsService: configsService,
                errorHandler: errorHandler,
                logger: logger,
                deepCompare: deepCompare,
                $window: $window,
                $uibModal: $modal,
                settingsService: settingsService,
                $filter: $filter,
                $timeout: $timeout,
                userStorage: userStorage,
                preloadedSkinsList: preloadedSkinsList
        };
        $controller('ConfigurationController', dependency);

        $scope.onSkinSelect = function () {
            return function () {
                $timeout(function () {
                    $scope.resetConfigs($scope.filterOptions.skinId.id, true, true)
                })
            }()
        };

        $scope.filterOptions = {
            skinId: {id: preloadedSkinsList[0].id}
        };

        $scope.getLimitedWord = function(word, size){
            if(word.length <= size){
                return word;
            } else {
                return word.substr(0, size) + '...';
            }
        }

        function keyDownListener(event) {
            var  keyCode = event.keyCode;
            if (keyCode === 38){
                $scope.arrowUpListener();
            } else if(keyCode === 40) {
                $scope.arrowDownListener();
            } else if (keyCode === 13){
                $scope.enterListener();
            }
        }

        document.body.addEventListener('keydown', keyDownListener);
        $scope.$on("$destroy", function (event) {
            document.body.removeEventListener('keydown', keyDownListener);
        });
    }
    
]);